/* eslint-disable react/jsx-no-bind -- RHF Controller render-prop pattern, same as the typed v5 fields */
import noop from 'lodash/noop'
import PropTypes from 'prop-types'
import React from 'react'
import { Controller } from 'react-hook-form'
import Switch from 'react-switch'

import { SUCCESS, TEXT } from '../../../theme/colors'

import WithSwitchLabel from './WithSwitchLabel'

const HHFormSwitchField = ({ name, rules = undefined, label, control, onChange = noop, ...rest }) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        const { onBlur, onChange: onChangeHookForm, ..._rest } = field
        return (
          <WithSwitchLabel label={label}>
            <Switch
              checked={field?.value || false}
              handleDiameter={10}
              height={16}
              offColor={TEXT.secondary}
              width={32}
              onChange={value => {
                onChangeHookForm(value)
                onChange(value)
                onBlur()
              }}
              onColor={SUCCESS.main}
              {..._rest}
              {...rest}
            />
          </WithSwitchLabel>
        )
      }}
      rules={rules}
    />
  )
}

HHFormSwitchField.propTypes = {
  control: PropTypes.object.isRequired,
  label: PropTypes.string,
  name: PropTypes.string,
  rules: PropTypes.object,
  onChange: PropTypes.func,
}

export default HHFormSwitchField
